
import React, {useEffect, useState} from 'react';
import {isEmpty, isUndefined, map} from 'lodash';
import {bool, object} from 'prop-types';
import Icon from '@sabre/spark-react-core/build/icon';
import Tooltip from '@sabre/spark-react-core/build/tooltip';
import SelectInput from '@sabre/spark-react-core/build/selectinput';
import Button from '@sabre/spark-react-core/build/button';

import {DateUtil} from '../../../utils/date-util.js';
import {
    DASHBOARD_HISTORY_DAYS_CONFIG_KEY,
    DASHBOARD_TOP_TABS_VALUE,
    DEFAULT_DASHBOARD_HISTORY_DAYS,
    NOTIFICATION_STATUS, SIZE
} from '../../../utils/constants.js';
import {
    AGGREGATION_DATES,
    COMPETITION_SUMMARY_DATE_DIFF_THRESHOLD,
    DASHBOARD_SEARCH_CRITERIA_KEYS,
    RECOMMENDATION_SUMMARY_DATE_DIFF_THRESHOLD
} from '../charts-and-grids/charts-util.js';
import {getClonedObject} from '../../../utils/common-util.js';
import {
    ALL_OPTIONS_KEY,
    CRITERIA_CATEGORY_AGGREGATION_DATE,
    getDefaultSearchCriteria,
    getDefaultStartEndDate,
    getLabelValuePairFromConfig,
    IS_ERROR_KEY,
    OPERATOR_OPTIONS,
    PICKUP_OPTIONS_FROM_KEY,
    SELECTED_VALUE_KEY,
    SELECTED_VALUES_KEY,
    TITLE_KEY
} from './search-criteria-modal-util.js';
import {getLabelValuePair, getSimpleHepProperty} from '../app-configs-util/app-configs-util.js';

import SearchCriteriaModalAddRow from './search-criteria-modal-add-row.jsx';
import MessageAlert from '../../../ui-components/message-alert/message-alert.jsx';
import DateRange from '../../../ui-components/date-range/date-range.jsx';

const SearchCriteriaModalContent = ({
                                        appConfigs,
                                        isShowNotification,
                                        isDateOutOfRange,
                                        isSaveCriteriaExist,
                                        isSaveCriteriaSaved,
                                        isClearSearchCriteria,
                                        isEmptyFieldPresent,
                                        savedCriteriaList,
                                        selectedSavedCriteria,
                                        setSelectedSavedCriteria,
                                        recommCompetitor,
                                        setSearchCriteriaHandler,
                                        setAggregationDateHandler,
                                        searchCriteriaContinueButtonOnClickHandler,
                                        searchCriteriaCancelButtonOnClickHandler,
                                        startEndDate
                                    }) => {
    const [selectedSavedCriteriaUpdated, setSelectedSavedCriteriaUpdated] = useState('');
    const [addedSearchCriteria, setAddedSearchCriteria] = useState([getDefaultSearchCriteria()]);
    const addCriteriaRow = () => setAddedSearchCriteria([...addedSearchCriteria, getDefaultSearchCriteria()]);
    const removeCriteriaRow = i => {
        const updatedSearchCriteria = getClonedObject(addedSearchCriteria);
        setAddedSearchCriteria([...updatedSearchCriteria.slice(0, i), ...updatedSearchCriteria.slice(i + 1)]);
    };
    const getDisplayHistoryDays = () => {
        const displayHistoryDays = getSimpleHepProperty(appConfigs, DASHBOARD_HISTORY_DAYS_CONFIG_KEY);
        return isUndefined(displayHistoryDays) ? DEFAULT_DASHBOARD_HISTORY_DAYS : displayHistoryDays;
    };
    useEffect(() => {
        setAddedSearchCriteria([getDefaultSearchCriteria()]);
    }, [isClearSearchCriteria]);

    useEffect(() => {
        setSearchCriteriaHandler(addedSearchCriteria);
    }, [addedSearchCriteria]);

    useEffect(() => {
        setSelectedSavedCriteriaUpdated(selectedSavedCriteria);
    }, [selectedSavedCriteria]);

    const generateSearchRows = addedSearchCriteria => {
        const searchRows = [];
        for (let i = 0; i < addedSearchCriteria.length; i++) {
            searchRows.push(
                <div key={`row-${i}`} className='row'>
                    <SearchCriteriaModalAddRow
                        isEmptyFieldPresent={isEmptyFieldPresent}
                        addedSearchCriteria={addedSearchCriteria}
                        rowIndex={i}
                        rowValue={addedSearchCriteria[i]}
                        appConfigs={appConfigs}
                        updateSearchCriteria={setAddedSearchCriteria}
                        recommCompetitor={recommCompetitor}
                    />

                    <div className='col-xs-1'>
                        <div className='spark-popover-group spark-mar-t-1'>
                            {
                                i !== 0 &&
                                <>
                                    <Tooltip
                                        anchorX='top'
                                        toggleEl={<Icon name='trash' style='fill' size={SIZE.MEDIUM}
                                                        label='Delete the search criteria rule'
                                                        onClick={() => removeCriteriaRow(i)}/>}
                                    >Delete the search criteria rule</Tooltip>&nbsp;
                                </>
                            }
                            {
                                i === (addedSearchCriteria.length - 1) &&
                                <>
                                    <Tooltip
                                        anchorX='top'
                                        toggleEl={<Icon name='math-add-circle' style='fill' size={SIZE.MEDIUM}
                                                        label='Add a search criteria rule' onClick={addCriteriaRow}/>}
                                    >Add a search criteria rule</Tooltip>
                                </>
                            }
                        </div>
                    </div>
                </div>
            );
        }

        return searchRows;
    };


    const getNotificationHtml = (isShowNotification, isShowErrorMesg, isOutOfRange, isSaveCriteriaExist, isSaveCriteriaSaved) => {

        if (isShowNotification) {
            return <div className='row spark-mar-b-1'>
                <div className='col-xs-12'>
                    <MessageAlert
                        content=''
                        role='alert'
                        status={NOTIFICATION_STATUS.WARNING}
                        title='No search results found'
                        type='container'
                    />
                </div>
            </div>;
        }

        if (isShowErrorMesg) {
            return <div className='row spark-mar-b-1'>
                <div className='col-xs-12'>
                    <MessageAlert
                        content=''
                        role='alert'
                        status={NOTIFICATION_STATUS.ERROR}
                        title='All fields are mandatory'
                        type='container'
                    />

                </div>
            </div>;
        }

        if (isOutOfRange) {
            return <div className='row spark-mar-b-1'>
                <div className='col-xs-12'>
                    <MessageAlert
                        content=''
                        role='alert'
                        status={NOTIFICATION_STATUS.ERROR}
                        title={`Date range should be within ${(DASHBOARD_TOP_TABS_VALUE.COMPETITION === recommCompetitor) ? COMPETITION_SUMMARY_DATE_DIFF_THRESHOLD : RECOMMENDATION_SUMMARY_DATE_DIFF_THRESHOLD} days`}
                        type='container'
                    />

                </div>
            </div>;
        }

        if (isSaveCriteriaExist) {
            return <div className='row spark-mar-b-1'>
                <div className='col-xs-12'>
                    <MessageAlert
                        content='Existing search criteria will be overwritten. Do you want to continue?'
                        role='alert'
                        status={NOTIFICATION_STATUS.WARNING}
                        title={'Search criteria with the given name already exists.'}
                        type='container'
                    />

                    <div className='col-xs-12 col-sm-4'>
                        <nav className='spark-btn-group spark-mar-t-1'>
                            <Button
                                className='spark-btn-group-primary'
                                size={Button.SIZE.SMALL}
                                onClick={() => searchCriteriaContinueButtonOnClickHandler(selectedSavedCriteriaUpdated)}
                            >
                                Continue
                            </Button>
                            <Button
                                className='spark-btn-group-secondary'
                                size={Button.SIZE.SMALL}
                                secondary
                                onClick={() => searchCriteriaCancelButtonOnClickHandler()}
                            >
                                Cancel
                            </Button>
                        </nav>
                    </div>

                </div>
            </div>;
        }

        if (isSaveCriteriaSaved) {
            return <div className='row spark-mar-b-1'>
                <div className='col-xs-12'>
                    <MessageAlert
                        content=''
                        role='alert'
                        status={NOTIFICATION_STATUS.SUCCESS}
                        title='Your criteria have been saved'
                        type='container'
                    />
                </div>
            </div>;
        }

        return null;
    };

    const isShowErrorMesg = isEmptyFieldPresent;
    const savedCriteriasOptions = getLabelValuePair(savedCriteriaList, TITLE_KEY);
    const titleSavedCriteriaMap = {};
    savedCriteriaList && !isEmpty(savedCriteriaList) && map(savedCriteriaList, eachValue => {
        const savedCriterias = [];
        map(eachValue.value.rules, eachRule => {
            let savedCriteria = {
                criteriaCategory: {},
                criteriaName: {},
                criteriaOperator: {},
                criteriaValue: {}
            };
            if (eachRule.category === DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_AGGREGATION_DATE) {
                savedCriteria[CRITERIA_CATEGORY_AGGREGATION_DATE] = eachRule.category;
                savedCriteria[AGGREGATION_DATES.AGGREGATION_FROM_DATE] = eachRule.leftOperand;
                savedCriteria[AGGREGATION_DATES.AGGREGATION_TO_DATE] = eachRule.rightOperand;
            } else {
                savedCriteria.criteriaCategory[PICKUP_OPTIONS_FROM_KEY] = DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_CATEGORY;
                savedCriteria.criteriaCategory[SELECTED_VALUE_KEY] = eachRule.category;
                savedCriteria.criteriaName[PICKUP_OPTIONS_FROM_KEY] = eachRule.category;
                savedCriteria.criteriaName[SELECTED_VALUE_KEY] = eachRule.criterion;
                savedCriteria.criteriaOperator = (eachRule.operator === OPERATOR_OPTIONS[0].label ? OPERATOR_OPTIONS[0].value : eachRule.operator);
                savedCriteria.criteriaValue[PICKUP_OPTIONS_FROM_KEY] = eachRule.criterion;
                savedCriteria.criteriaValue[SELECTED_VALUES_KEY] = getLabelValuePair(eachRule.leftOperand);
                savedCriteria.criteriaValue[IS_ERROR_KEY] = false;
                savedCriteria.criteriaValue[ALL_OPTIONS_KEY] = getLabelValuePairFromConfig(appConfigs, eachRule.criterion);
            }
            savedCriterias.push(savedCriteria);
        });
        titleSavedCriteriaMap[eachValue.title] = savedCriterias;
    });


    const populateSavedSearchCriteriaList = selectedValue => {
        setSelectedSavedCriteria(selectedValue);
        let savedCriteriaWithoutDateCriteria = [];
        if (!isEmpty(selectedValue)) {
            const savedCriteria = titleSavedCriteriaMap[selectedValue];
            map(savedCriteria, eachCriteria => {
                if (eachCriteria[CRITERIA_CATEGORY_AGGREGATION_DATE] && eachCriteria[CRITERIA_CATEGORY_AGGREGATION_DATE] === DASHBOARD_SEARCH_CRITERIA_KEYS.CRITERIA_AGGREGATION_DATE) {
                    setAggregationDateHandler(eachCriteria[AGGREGATION_DATES.AGGREGATION_FROM_DATE], eachCriteria[AGGREGATION_DATES.AGGREGATION_TO_DATE]);
                } else {
                    savedCriteriaWithoutDateCriteria.push(eachCriteria);
                }
            });
        } else {
            const defaultStartEndDate = getDefaultStartEndDate(DateUtil.DATE_FORMATS.MONTH_DAY_YEAR);
            setAggregationDateHandler(defaultStartEndDate.start, defaultStartEndDate.end);
            savedCriteriaWithoutDateCriteria.push(getDefaultSearchCriteria());
        }
        setAddedSearchCriteria(savedCriteriaWithoutDateCriteria);
    };

    return (
        <>
            <div className='spark-mar-t-2 spark-mar-b-3'>
                {getNotificationHtml(isShowNotification, isShowErrorMesg, isDateOutOfRange, isSaveCriteriaExist, isSaveCriteriaSaved)}
                <div className='col-xs-12 col-sm-5'>
                    <SelectInput
                        key={'save-criteria-key'}
                        name={'save-criteria'}
                        options={savedCriteriasOptions}
                        label={'Select a Saved Criteria'}
                        value={selectedSavedCriteriaUpdated}
                        onChange={selectedValue => populateSavedSearchCriteriaList(selectedValue)}
                    />
                </div>
            </div>

            <div className='row spark-mar-t-2'>
                <div className='col-xs-12 col-sm-5'>
                    <label>Date</label>
                    <DateRange
                        configs={{
                            inputElementDateRangeId: 'search-criteria-date-range',
                            format: DateUtil.DATE_FORMATS.MONTH_DAY_YEAR,
                            minDate: DateUtil.formatDate(DateUtil.subtractDaysInMoment(DateUtil.getNowMoment(), getDisplayHistoryDays()), DateUtil.DATE_FORMATS.DAY_MONTH_YEAR),
                            maxDate: DateUtil.formatDate(DateUtil.getNowMoment(), DateUtil.DATE_FORMATS.DAY_MONTH_YEAR),
                            startDate: startEndDate.start,
                            endDate: startEndDate.end,
                            enableRanges: true,
                            recommCompetitor: recommCompetitor,
                            dateOnChangeHandler: setAggregationDateHandler
                        }}
                        iconSize={SIZE.MEDIUM}
                        isForceRender={isClearSearchCriteria}
                    />
                </div>
            </div>
            <div className='spark-mar-t-2'>
                {generateSearchRows(addedSearchCriteria)}
            </div>
        </>
    );
};

SearchCriteriaModalContent.propTypes = {
    appConfigs: object,
    isEmptyFieldPresent: bool
};

export default SearchCriteriaModalContent;
